import styled from "styled-components";

const NewsContent = styled.div`
  font-family: system-ui, "Inter", sans-serif;
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  line-height: 24.48px;
  font-weight: 300 !important;
  color: rgb(26, 26, 26);

  p {
    margin-top: 0;
    margin-bottom: 24px;
  }

  ul, ol {
    margin: 0;
    margin-bottom: 16px;
    padding-left: 40px;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: antialiased !important;
  }

  ul {
    list-style: disc !important;

    li {
      list-style-type: disc !important;
      -webkit-font-smoothing: initial !important;
      -moz-osx-font-smoothing: initial !important;
    }
  }

  ol {
    list-style: decimal !important;

    li {
      list-style-type: decimal !important;
      -webkit-font-smoothing: initial !important;
      -moz-osx-font-smoothing: initial !important;
    }
  }

  a {
    color: ${props => props.theme.action};
    text-decoration: underline;
  }

  b, strong {
    font-weight: 600;
  }
  img {
    margin-top: 0;
    margin-bottom: 0;
    height: auto;
    max-width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 15px;
    scroll-margin: 20px;
    font-weight: 700;
  }

  h1 {
    font-size: 22px;
    line-height: 29px;
  }
  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 590;
  }
  h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 590;
  }
  h4 {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  h5 {
    font-size: 16px;
    font-weight: 590;
    line-height: 24px;
  }
  h6 {
    font-size: 13px;
    margin: 1em 0 .5em;
    line-height: 1.24;
  }

  table {
    white-space: pre-wrap;
    border-spacing: 0;
    table-layout: fixed;
    margin: 36px 0;
    width: 100%;
    border: 1px solid #c2c4bb;
    border-radius: 6px;
    border-collapse: collapse;
    margin: 24px 0;

    tbody {
      vertical-align: top;
    }

    th {
      padding: 8px;
      position: relative;
      border: 1px solid #c2c4bb;
      border-collapse: collapse;
      background-color: transparent;
    }

    td {
      padding: 8px;
      position: relative;
      border: 1px solid #c2c4bb;
      border-collapse: collapse;
    }
  }

  pre {
    padding: 16px;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f3f3f1;
    border-radius: 3px;
  }
`

export default NewsContent